export const ONLINE_VOTING_TEMPLATE_IDS = (process.env.REACT_APP_ONLINE_VOTING_TEMPLATE_IDS || '140')
  .split(',')
  .map(s => Number(s.trim()))
  .filter(n => Number.isFinite(n));

export const GENERIC_LETTER_NOTICE_TEMPLATE_ID = Number(
  process.env.REACT_APP_GENERIC_LETTER_NOTICE_TEMPLATE_ID || 43
);

export const sendToOptions = [
    { name: 'All Owners/Residents/Agents', value: 'owners_residents_agents' },
    { name: 'All Owners (service of Notice Address)', value: 'owners' },
    { name: 'All Residents', value: 'residents' },
    { name: 'All Agents', value: 'agents' },
    { name: 'All Owners/Agents', value: 'owners_agents' },
    { name: 'All Residents/Agents', value: 'residents_agents' },
    { name: 'All Owners/Residents', value: 'owners_residents' },
    { name: 'Lot only - specify in next field which lot and to who i.e. Resident/Owner', value: 'lotOnly' },
    { name: 'Committee Members only', value: 'committeeMembers' },
    { name: 'Tenants only', value: 'tenants' }
];

export const sendingPreferenceOptions = [
    { name: 'Email', value: 'email' },
    { name: 'Postal', value: 'postal' }
];

export const getInitialFormData = (userEmail) => ({
    recipientSource: 'strata',
    name: '',
    sendingOption: 'sending-from-me',
    email: userEmail || '',
    sending_preference: '',
    delivery_preference: '',
    planType: 'SP',
    planNumber: '',
    databaseName: '',
    branch_id: '',
    priority: 'false',
    sendTo: '',
    sending: '',
    dynamicMinutesSelection: '',
    dynamicafssCopyToLO: '',
    otherSending: '',
    afssOption: '',
    minutesFor: '',
    windowLockApproval: '',
    contractorName: '',
    windowLockProceedWith: '',
    windowLockSpecialRequests: '',
    specialLeviesResolved: '',
    specialLeviesMotion: '',
    specialLeviesNotes: '',
    sm_name: '',
    sm_email: '',
    sm_phone: '',
    last_agm_date: '',
    last_egm_date: '',
    last_committee_date: '',
    associated_date_fields: [],
    skip_meeting_update: false,
    online_voting_open_for_voting: null,
    online_voting_show_on_portal: null,
    colorPages: 'false',
    notes: '',
    files: [],
    smata_config_id: null,
    smata_template_doc_url: null,
    smata_category: '',
    emailOverrideGroupingCategories: null,
    sendReminders: '',
    reminderDate: '',
    lotsUserTypes: [],
    selectedLots: [],
    lotsSelectionType: 'enter_lots',
    searchLots: '',
    lots_sprated: '',
    lotRangeStart: '',
    lotRangeEnd: '',
    meetingLocation: '',
    zoomMeetingId: '',
    zoomMeetingPassword: '',
    mergeFieldsData: {},
    emailSubject: '',
    inbox_id: '',
    channel_id: '',
    channel_send_as: '',
    custom_document_name: '',
    issueType: '',
    selectedMeetingId: null,
    signature_id: '',
    send_later: false,
    scheduled_time: '',
    notify_submitter: false,
    preload_from_process_street: false,
    process_street_workflow_run: '',
    customRecipients: [],
    single_sided: false,
    invoice_approvers_enabled: false,
    num_approvers_required: '',
    min_approver_amount: '',
    selected_external_approvers: [],
    selected_internal_approvers: [],
    hidden_internal_approvers: []
});

export const INITIAL_ERRORS = {
    email: false,
    inbox: false,
    channel: false,
    channelSuggestion: false,
    planNumber: false,
    sendTo: false,
    sending: false,
    windowLockApproval: false,
    contractorName: false,
    windowLockProceedWith: false,
    windowLockSpecialRequests: false,
    specialLeviesResolved: false,
    specialLeviesMotion: false,
    skip_meeting_update: false,
    fileUpload: false,
    mergedPDF: false,
    planNumberSuggestion: false,
    emailSuggestion: false,
    custom_document_name: false,
    mergeFields: {},
    meetingLocation: false,
    zoomMeetingId: false,
    zoomMeetingPassword: false,
    meetingSuggestion: false,
    send_later: false,
    scheduled_time: false,
    process_street_workflow_run: false,
    customRecipientsValidation: false,
    customRecipientsValidationMessage: ''
};
